export default [
	{
		settings: true,
		text: "Trip",
		value: "trip_id",
		func: true,
		valueFilter: "filter_trip_id",
		model: { value: 'list' },
		sortable: true,
		attach: true,
		flexJc: true
	},
	{
		settings: true,
		text: "Load",
		value: "load_id",
		func: true,
		valueFilter: "filter_load_id",
		model: { value: 'list' },
		sortable: true,
		attach: true,
		flexJc: true
	},
	{
		settings: true,
		text: "Broker",
		value: "broker_name",
		func: true,
		valueFilter: "filter_broker_name",
		model: { value: 'list' },
		sortable: true,
		attach: true,
		flexJc: true
	},
	{
		settings: true,
		text: "Broker load",
		value: "broker_number",
		func: true,
		valueFilter: "filter_broker_number",
		model: { value: 'list' },
		sortable: true,
		attach: true,
		flexJc: true
	},
	{
		settings: true,
		text: "Customer",
		value: "сarrier",
		func: true,
		valueFilter: "filter_customer",
		model: { value: 'list' },
		sortable: true,
		attach: true,
		flexJc: true
	},
	{
		settings: true,
		text: "Truck#",
		value: "truck",
		func: true,
		valueFilter: "filter_truck",
		model: { value: 'list' },
		sortable: true,
		attach: true,
		flexJc: true
	},
	{
		settings: true,
		text: "Trailer#",
		value: "trailer",
		func: true,
		valueFilter: "filter_trailer",
		model: { value: 'list' },
		sortable: true,
		attach: true,
		flexJc: true
	},
	{
		settings: true,
		text: "Trailer type",
		value: "trailer_type",
		func: true,
		valueFilter: "filter_trailer_type",
		model: { value: 'list' },
		sortable: true,
		attach: true,
		flexJc: true
	},
	{
		settings: true,
		text: "Driver name",
		value: "driver",
		func: true,
		valueFilter: "filter_driver",
		model: { value: 'list' },
		sortable: true,
		attach: true,
		flexJc: true
	},
	{
		settings: true,
		text: "Dispatcher",
		value: "dispatcher",
		valueFilter: "filter_dispatcher",
		model: { value: 'list' },
		func: true,
		sortable: true,
		attach: true,
		flexJc: true
	},
	{
		settings: true,
		text: "Route",
		value: "routs",
		valueFilter: 'filter_rout_city',
		model: {
			value: 'address',
			filters: [
				{ filter: "filter_rout_state", label: "Select state" },
				{ filter: "filter_rout_city", label: "Select city" },
			]
		},
		func: true,
		sortable: true,
		attach: true,
		flexJc: true
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		valueFilter: 'filter_gross',
		model: { value: 'number' },
		func: true,
		sortable: true,
		attach: true,
		flexJc: true,
		left: true
	},
	{
		settings: true,
		text: "RPM",
		func: true,
		value: "rpm",
		valueFilter: 'filter_rpm',
		model: { value: 'number' },
		sortable: true,
		attach: true,
		align: 'center',
		flexJc: true,
		left: true
	},
	{
		settings: true,
		text: "Total miles",
		func: true,
		value: "mileage_total",
		valueFilter: 'filter_mileage_total',
		model: { value: 'number' },
		sortable: true,
		attach: true,
		align: 'center',
		flexJc: true,
		left: true
	},
	{
		settings: true,
		text: "Empty miles",
		func: true,
		value: "mileage_empty",
		valueFilter: 'filter_mileage_empty',
		model: { value: 'number' },
		sortable: true,
		attach: true,
		align: 'center',
		flexJc: true,
		left: true
	}
];
